import { Language } from "../constants/enums";

/**
 * Maps Language enum to Intl.DateTimeFormat locale strings
 * Used for date/number/currency formatting
 */
export const LANGUAGE_LOCALE_MAP: Record<Language, string | undefined> = {
  [Language.RU]: "ru-RU",
  [Language.EN]: "en-US",
  [Language.ES]: "es-ES",
  [Language.FR]: "fr-FR",
  [Language.DE]: "de-DE",
  [Language.ZH]: "zh-CN",
  [Language.IN]: "hi-IN",
  [Language.PT]: "pt-PT",
  [Language.UNSPECIFIED]: undefined,
};

/**
 * Maps browser language prefixes to Language enum
 */
const BROWSER_LANG_MAP: Record<string, Language> = {
  ru: Language.RU,
  es: Language.ES,
  fr: Language.FR,
  de: Language.DE,
  zh: Language.ZH,
  hi: Language.IN,
  pt: Language.PT,
  en: Language.EN,
};

/**
 * Get browser language and map it to our Language enum
 * @returns Language enum value based on browser language
 */
export function getBrowserLanguage(): Language {
  const browserLang = navigator.language.toLowerCase();
  const langPrefix = browserLang.split("-")[0];

  return BROWSER_LANG_MAP[langPrefix] ?? Language.EN;
}

/**
 * Get Intl locale string for a Language enum value
 * @param language - Language enum value
 * @returns Intl-compatible locale string (e.g., 'en-US', 'ru-RU')
 */
export function getIntlLocale(language: Language): string {
  return LANGUAGE_LOCALE_MAP[language] ?? "en-US";
}

/**
 * Мапинг Language enum на строковые коды языков
 */
const LanguageCodeDictionary: Record<Language, string> = {
  [Language.UNSPECIFIED]: "",
  [Language.RU]: "ru",
  [Language.EN]: "en",
  [Language.ES]: "es",
  [Language.FR]: "fr",
  [Language.DE]: "de",
  [Language.ZH]: "zh",
  [Language.IN]: "in",
  [Language.PT]: "pt",
};

export const GetLanguageCode = (language: Language): string => {
  return LanguageCodeDictionary[language] || "en";
};
